function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    "data-testid": "iconSvg",
    focusable: "false",
    height: "30px",
    viewBox: "0 0 24 24",
    width: "30px",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      display: "inline-block",
      verticalAlign: "middle"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-testid": "iconPath",
    fillRule: "evenodd",
    d: "M7.2 19a.78.78 0 01-.566-.249l-4.4-4.666a.885.885 0 010-1.2.768.768 0 011.132 0l3.778 4.007 9.04-11.583a.765.765 0 011.125-.113c.341.298.39.833.107 1.193l-9.6 12.303a.772.772 0 01-.578.306C7.225 19 7.213 19 7.2 19zm4.438-.002a.775.775 0 00.578-.306l9.6-12.303a.881.881 0 00-.107-1.193.766.766 0 00-1.125.113l-9.04 11.583-.178-.189a.768.768 0 00-1.132 0 .885.885 0 000 1.2l.8.848A.78.78 0 0011.6 19c.013 0 .025 0 .038-.002z",
    style: {
      fill: "currentcolor"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleCheck);
export default __webpack_public_path__ + "static/media/doubleCheck.0f9c83352d409e6a9d3f4f13950473db.svg";
export { ForwardRef as ReactComponent };